module.exports = __webpack_public_path__ + "static/media/undraw_deliveries_131a.11415259.svg";